// extracted by mini-css-extract-plugin
export const button = "button-module--button--37hjR";
export const large = "button-module--large--2XEK1";